import { Component, inject, Input, OnInit } from '@angular/core';
import { GrowAccountOverview, GrowOverviewInvestment, GrowProjectStatus } from '@inyova/grow';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-inyova-grow-breakdown-modal',
  templateUrl: './inyova-grow-breakdown-modal.component.html',
  styleUrls: ['./inyova-grow-breakdown-modal.component.scss'],
  standalone: false
})
export class InyovaGrowBreakdownModalComponent implements OnInit {
  private modalController = inject(ModalController);

  @Input() accountCurrency: string;
  @Input() overview: GrowAccountOverview;
  @Input() portfolioValue: number;

  investments: GrowOverviewInvestment[] = [];
  commitments: GrowOverviewInvestment[] = [];

  info = {
    accountValueInfo: false,
    principalPerProjectInfo: false,
    committedInfo: false
  };

  ngOnInit(): void {
    for (const investment of this.overview.investments) {
      if (investment.status === GrowProjectStatus.INVESTED) {
        this.investments.push(investment);
      } else if (investment.status === GrowProjectStatus.COMMITTED) {
        this.commitments.push(investment);
      }
    }
  }

  onDismiss() {
    void this.modalController.dismiss();
  }

  onShowInfo(block: 'accountValueInfo' | 'principalPerProjectInfo' | 'committedInfo') {
    this.info[block] = !this.info[block];
  }
}
